// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PF1k","inner":"Footer_inner__12Rpw","nextIcon":"Footer_nextIcon__2WFHa","innerLeft":"Footer_innerLeft__2uRS2"};